// types
import type { GuardProps } from 'types/auth'
// project import
import { APP_DEFAULT_PATH } from 'config'

import useAuth from 'hooks/useAuth'
import { useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

// ==============================|| GUEST GUARD ||============================== //

// Routes that should be accessible to logged-in users (exceptions to GuestGuard)
const LOGGED_IN_ALLOWED_ROUTES = ['/require-password-change', '/password-reset-success']

function GuestGuard({ children }: GuardProps) {
  const { isLoggedIn } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Allow logged-in users to access password change routes
    if (isLoggedIn && LOGGED_IN_ALLOWED_ROUTES.includes(location.pathname)) {
      return
    }

    if (isLoggedIn) {
      // Check window.history.state for targetUrl
      let targetUrl = window.history.state?.targetUrl || APP_DEFAULT_PATH

      // If targetUrl is '/', change it to '/dashboard'
      if (targetUrl === '/') {
        targetUrl = '/dashboard'
      }

      console.log('targetUrl', targetUrl)

      // Clear the targetUrl from window.history.state
      const newState = { ...window.history.state }
      delete newState.targetUrl
      window.history.replaceState(newState, document.title)

      navigate(targetUrl, {
        replace: true,
        state: { from: window.location.pathname },
      })
    }
  }, [isLoggedIn, navigate, location.pathname])

  return children
}

export default GuestGuard
